import { useState, useEffect } from "react";

/**
 * AnimatedEllipsis - Displays an animated "..." loading indicator.
 *
 * @param interval - Time in ms between dot changes (default: 400ms)
 * @param maxDots - Maximum number of dots to display (default: 3)
 *
 * @example
 * <span>Loading<AnimatedEllipsis /></span>
 */
export function AnimatedEllipsis({
  interval = 400,
  maxDots = 3,
}: {
  interval?: number;
  maxDots?: number;
}) {
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setDotCount((prev) => (prev >= maxDots ? 0 : prev + 1));
    }, interval);

    return () => clearInterval(timer);
  }, [interval, maxDots]);

  const dots = ".".repeat(dotCount);
  const spacer = "\u00A0".repeat(maxDots - dotCount);

  return (
    <span className="inline-block" style={{ minWidth: `${maxDots * 0.5}em` }}>
      {dots}
      {spacer}
    </span>
  );
}

export default AnimatedEllipsis;
